import axios from "axios";

// Empty means same origin: in production the frontend is served by Cloudflare
// Pages, which proxies /api/* to Cloud Run, so the browser only ever sees one
// host and the session cookie stays first-party.
const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BASE}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
